export const adminService = {
  /**
   * Obtenir les statistiques globales
   */
  getStatistics: async () => {
    return {
      success: false,
      error:
        'Admin: à implémenter via Firestore (requêtes) et/ou Cloud Functions. API Express supprimée en mode Firebase-only.',
    };
  },

  /**
   * Obtenir tous les utilisateurs
   */
  getAllUsers: async (filters = {}) => {
    return { success: false, error: 'Admin users: non implémenté (Firebase-only).', users: [] };
  },

  /**
   * Mettre à jour le rôle d'un utilisateur
   */
  updateUserRole: async (userId, role) => {
    return { success: false, error: 'Admin rôle: à implémenter via Cloud Functions (setCustomClaims + Firestore).' };
  },

  /**
   * Activer/Désactiver un utilisateur
   */
  toggleUserStatus: async (userId) => {
    return { success: false, error: 'Admin statut: à implémenter via Cloud Functions.' };
  },

  /**
   * Obtenir les statistiques de connexions
   */
  getConnectionStatistics: async (period = 'day', startDate = null, endDate = null, role = null) => {
    return { success: false, error: 'Admin connections stats: non implémenté (Firebase-only).' };
  },

  /**
   * Obtenir les détails des connexions
   */
  getConnectionDetails: async (period = 'day', startDate = null, endDate = null, role = null, page = 1, limit = 100) => {
    return { success: false, error: 'Admin connections details: non implémenté (Firebase-only).' };
  },

  /**
   * Exporter le rapport de connexions
   */
  exportConnectionReport: async (period = 'day', startDate = null, endDate = null, role = null, format = 'csv') => {
    return { success: false, error: 'Export admin: non implémenté (Firebase-only).' };
  },
};

